import { render, staticRenderFns } from "./LoadApp.vue?vue&type=template&id=2587b900"
import script from "./LoadApp.vue?vue&type=script&lang=js"
export * from "./LoadApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports